import { render, staticRenderFns } from "./ShowIDPopUp.vue?vue&type=template&id=6df0d754&scoped=true"
import script from "./ShowIDPopUp.vue?vue&type=script&lang=ts"
export * from "./ShowIDPopUp.vue?vue&type=script&lang=ts"
import style0 from "./ShowIDPopUp.vue?vue&type=style&index=0&id=6df0d754&prod&lang=scss&scoped=true"
import style1 from "./ShowIDPopUp.vue?vue&type=style&index=1&id=6df0d754&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df0d754",
  null
  
)

export default component.exports